import React, { Fragment, useContext } from "react";
import ReactDOM from "react-dom";
import { ScreenContext } from "../../../contexts/ScreenContext";
import { useMediaQuery } from "react-responsive";

import styles from "./ModalTransparent.module.css";

const Backdrop = (props) => {
  return <div className={styles.backdrop} />;
};

const ModalOverlay = (props) => {
  return (
    <div className={styles.modal}>
      <div className={styles.content}>{props.children}</div>
    </div>
  );
};

const ModalTransparent = (props) => {
  const { smallScreen } = useContext(ScreenContext);
  const smScreen = useMediaQuery(smallScreen);

  return (
    <Fragment>
      {smScreen ? (
        <Fragment>
          <Backdrop />
          <ModalOverlay>{props.children}</ModalOverlay>
        </Fragment>
      ) : (
        <Fragment>
          <div className={styles.backdrop}>
            <ModalOverlay>{props.children}</ModalOverlay>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

export default ModalTransparent;
